<template>
  <shipblu-card :cardLoading="trackingCardLoading" class="p-5 relative">
    <div v-if="!gotVerifyAlert" class="verify-alert">
      <p class="font-semibold text-sm">
        {{ $t('Our new') }}
        <span class="text-primary">{{ $i18n.locale === 'en' ? 'ShipBlu Verify™' : '™ShipBlu Verify' }}</span>
        {{ $t('technology is now verifying delivery attempts. Our system will automatically contact the customer to confirm the attempt reason provided by the courier. This ensures accurate and reliable information, improving our service and your experience.') }}
      </p>
      <div class="flex justify-end">
        <vs-button @click="gotVerify" class="py-2 px-5 font-semibold text-sm">{{ $t('Got It') }}</vs-button>
      </div>
    </div>
    <div class="flex justify-between items-center mb-4">
      <p class="header text-lg">
        <span>{{ $route.params.type === 'delivery-orders' ?  $t('Delivery Attempts') + ' ' : $route.params.type === 'returns' ? $t('Return Attempts') + ' ' : $t('Cash Collection Attempts') + ' ' }}</span>
        <span class="text-red">{{ '(' + trackings.filter(item => item.status === 'delivery_attempted' || item.status === 'return_attempted').length + ')' }}</span>
      </p>
      <vx-tooltip position="top" color="#434343" :text="`${$t('Our new ShipBlu Verify™ technology is now verifying delivery attempts. Our system will automatically contact the customer to confirm the attempt reason provided by the courier. This ensures accurate and reliable information, improving our service and your experience.')}`">
        <span class="material-icons-outlined text-sm cursor-pointer flex">info</span>
      </vx-tooltip>
    </div>
    <div class="attemp-card">
      <div :style="`border: 1px solid ${attemptBorder(item)}`" class="mt-4 p-2 flex justify-between items-start" v-for="(item, index) in trackings.filter(item => item.status === 'delivery_attempted' || item.status === 'return_attempted').reverse()" :key="index">
        <div class="flex gap-2 leading-tight">
          <p class="text-black font-bold text-sm">{{ index === 0 ? $t('1st') : index === 1 ? $t('2nd') : index === 2 ? $t('3rd'): '' }}</p>
          <div>
            <p class="font-medium text-black text-sm">{{ $t(item.comment) }}</p>
            <p class="text-gray text-xs mt-2">{{ new Date(item.created).toLocaleDateString('fr-CA') }} {{ new Date(item.created).toLocaleTimeString() }}</p>
          </div>
        </div>
        <div>
          <vx-tooltip v-if="attemptBorder(item) === '#1C5BFE'" position="top" color="#434343" :text="`${$t('ShipBlu Verify™ contacted the customer, and the delivery attempt was confirmed.')}`">
            <img class="block cursor-pointer" width="25" src="@/assets/images/pages/confirmed-verify.png" alt="">
            <p class="text-sm text-primary flex justify-end material-icons-outlined">done_all</p>
          </vx-tooltip>
          <vx-tooltip v-if="attemptBorder(item) === '#FF6B6B'" position="top" color="#434343" :text="`${$t('ShipBlu Verify™ contacted the customer, and the delivery attempt was not confirmed.')}`">
            <img class="block cursor-pointer" width="25" src="@/assets/images/pages/denied-verify.png" alt="">
            <p class="text-sm text-danger flex justify-end material-icons-outlined">close</p>
          </vx-tooltip>
          <vx-tooltip v-if="attemptBorder(item) === '#6C84A3'" position="top" color="#434343" :text="`${$t('ShipBlu Verify™ contacted the customer, but the customer did not pick up the phone.')}`">
            <img class="block cursor-pointer" width="25" src="@/assets/images/pages/noAnswer-verify.png" alt="">
            <p class="text-sm text-grey flex justify-end material-icons-outlined">done</p>
          </vx-tooltip>
        </div>
      </div>
    </div>
  </shipblu-card>
</template>

<script>
import ShipbluCard from '../../../layouts/components/ShipbluCard.vue'

export default {
  props: ['trackingCardLoading', 'trackings', 'gotVerifyAlert', 'attemptsValidation'],
  data () {
    return {}
  },
  methods: {
    gotVerify () {
      this.$cookies.set('gotVerifyAlert', true, '100y')
      this.$emit('gotVerifyAlert', true)
    },
    attemptBorder (item) {
      if (this.attemptsValidation.length > 0) {
        if (this.attemptsValidation.filter((element) => element.attempt === item.id && element.status === 'confirmed').length > 0) {
          return '#1C5BFE'
        } else if (this.attemptsValidation.filter((element) => element.attempt === item.id && element.status === 'denied').length > 0) {
          return '#FF6B6B'
        } else if (this.attemptsValidation.filter((element) => element.attempt === item.id && element.status === 'no_answer').length > 0) {
          return '#6C84A3'
        }
      }
    }
  },
  components: {
    ShipbluCard
  }
}
</script>

<style lang="scss">
.attemp-card {
  & > div {
    border-radius: 10px;
    &:nth-child(1) {
      background: rgba(255, 183, 77, 0.06);
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.14);
    }
    &:nth-child(2) {
      background: rgba(255, 183, 77, 0.19);
    }
    &:nth-child(3) {
      background: rgba(255, 183, 77, 0.38);
    }
  }
  .border-primary {
    border: 1px solid #1C5BFE;
  }
}
</style>